const selectedCardsGroupsReducer = (data = "none", action) => {
    switch(action.type){
        case 'CHANGE_SELECTED_CARDSGROUPS':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default selectedCardsGroupsReducer;